import { c as _c } from "react/compiler-runtime";
// Removed unused import React from 'react';

type CheckboxCheckProps = {
  isSelected: boolean;
  className?: string;
};
const CheckboxCheck = t0 => {
  const $ = _c(5);
  const {
    isSelected
  } = t0;
  const t1 = `absolute left-0 top-0 w-4 h-4 pointer-events-none ${isSelected ? "opacity-100" : "opacity-0"}`;
  const t2 = isSelected ? 0 : 16;
  let t3;
  if ($[0] !== t2) {
    t3 = <path d="M4 8.5L7 11.5L12 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="square" strokeLinejoin="miter" className="text-quinary" style={{
      strokeDasharray: 16,
      strokeDashoffset: t2,
      transition: "stroke-dashoffset 0.2s ease-in-out"
    }} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t3) {
    t4 = <svg className={t1} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">{t3}</svg>;
    $[2] = t1;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default CheckboxCheck;